import { render } from "./formfile-upload.vue?vue&type=template&id=6b2c1380"
import script from "./formfile-upload.vue?vue&type=script&lang=js"
export * from "./formfile-upload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__